
import * as React from 'react';
import styled from 'styled-components';

import { getColor, getFontSize} from '@process-advisor/process-miner/shared/theme';
import { Metrics } from '@process-advisor/process-miner/components/influencer/metrics'
import { Values } from '@process-advisor/process-miner/components/influencer/values'
import { AttributeSelect } from '@process-advisor/process-miner/components/influencer/attributeSelect'
import { MinMaxMetric } from '@process-advisor/process-miner/components/influencer/minMaxMetric'
import { MinMaxTasks } from '@process-advisor/process-miner/components/influencer/minMaxTasks'
import { Typography } from '@mui/material';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events'
import { ShowSteps } from '@process-advisor/process-miner/components/influencer/showSteps';


const Wrapper = styled.div`
    background-color: white;
    width: 800px;
    margin-left: 35px;
    margin-top: 17px;
    padding: 5px;
`;

const Row1 = styled.div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 75px 170px 75px 150px 100px 50px;
  padding-bottom: 5px;
`;

const Row2 = styled.div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 75px 500px;
  padding-bottom: 5px;
`;

const Row3 = styled.div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 75px 240px 50px 220px;
  padding-bottom: 5px;
`;

const MetricLabel = styled.div`
    grid-row: 1 / 4 ;
    grid-column: 1 / 4 ;
`;

const MetricValue = styled.div`
    grid-row: 1 / 4 ;
    grid-column: 2 / 4 ;
`;

const ValuesLabel = styled.div`
    grid-row: 1 / 4 ;
    grid-column: 3 / 4 ;
`;

const ValuesValue = styled.div`
    grid-row: 1 / 4 ;
    grid-column: 4 / 4 ;
`;

const AttributeLabel = styled.div`
    grid-row: 2 / 4 ;
    grid-column: 1 / 2 ;
`;

const AttributeValue = styled.div`
    grid-row: 2 / 4 ;
    grid-column: 2 / 2 ;
`;


const TasksMinMaxLabel = styled.div`
    grid-row: 3 / 4 ;
    grid-column: 1 / 4 ;
`;

const TasksMinMaxValue = styled.div`
    grid-row: 3 / 4 ;
    grid-column: 2 / 4 ;
`;

const MetricMinMaxLabel = styled.div`
    grid-row: 3 / 4 ;
    grid-column: 3 / 4 ;
`;

const MetricMinMaxValue = styled.div`
    grid-row: 3 / 4 ;
    grid-column: 4 / 4 ;
`;

const Label = styled.div`
    font-size: ${getFontSize('smaller')};
    color: ${getColor('blue')};
`;

const Row4 = styled.div`
  display: grid;
  align-items: center;
  grid-row: 4 / 4 ;
  grid-column: 1 / 1 ;
  padding-bottom: 5px;
`;


export const InfluenceAnalysis_Options = () => {
    const [description, setDescription] = React.useState<String>('');

    React.useEffect(() => {
        setDescription(apiProvider.getRCDescription());
    }, []);

    React.useEffect(() => {

        const listener = () => {
            setDescription(apiProvider.getRCDescription());
        };        
        apiProvider.on(Event.setDiagramInfluenceAnalysis, listener);
        return () => {
            apiProvider.off(Event.setDiagramInfluenceAnalysis, listener);

        };
    }, []);

    const label = apiProvider.getEntityUpper() + 's:'

    return (
        <Wrapper>
            <Row1>
                <MetricLabel>
                    <Label>Metric:</Label>
                </MetricLabel>
                <MetricValue>
                    <Metrics/>
                </MetricValue>
                <ValuesLabel>
                    <Label>Metric sort:</Label>
                </ValuesLabel>
                <ValuesValue>
                    <Values/>
                </ValuesValue>
            </Row1>
            <Row2>
                <AttributeLabel>
                    <Label>Attributes:</Label>
                </AttributeLabel>
                <AttributeValue>
                    <AttributeSelect/>
                </AttributeValue>                
            </Row2>
            <Row3>
                <TasksMinMaxLabel>
                    <Label>{label}</Label>
                </TasksMinMaxLabel>
                <TasksMinMaxValue>
                    <MinMaxTasks/>
                </TasksMinMaxValue>
                <MetricMinMaxLabel>
                    <Label>Metric:</Label>
                </MetricMinMaxLabel>
                <MetricMinMaxValue>
                    <MinMaxMetric/>
                </MetricMinMaxValue>
            </Row3>
            <Row4>
                <Typography
                    variant="caption"
                    align="center"
                    sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'system-ui'
}}
                    component="div">
                    {description}
                </Typography>
            </Row4>               
        </Wrapper>
    );
};
